import { Request } from '@/http/request'

export function blackCountList(parameter: any){
  return Request.axiosInstance.post('/open/black-count/list', parameter)
}

export default { blackCountList }